import classNames from "classnames";
import React from "react";

const videoAds = [
    {
        id: 1, 
        title: "Pre - Rolls",
        desc: "A Pre-Roll Ad is a promotional video that plays before the content selected by the User",
        img: "https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/video-ads-pre-roll.png"
    },
    {
        id: 2, 
        title: "Mid - Rolls",
        desc: "Ads shown in between Content on Programs. Mid Roll Ads comprise a 100% Completion Rate.",
        img: "https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/video-ads-mid-roll.png"
    },
    {
        id: 3, 
        title: "Bumpers",
        desc: "Bumper ads are Short and Sweet six second ads that are aired between the shows causing minimal interruption to the viewing experience.",
        img: "https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/video-ads-bumpers.png"
    }
]
const displayAds = [
    {
        id: 1, 
        title: "Billboard (Home Page)",
        desc: "Ad will be placed on the Home Page of our Website/ Apps.",
        img: "https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/da-billboards.png"
    },
    {
        id: 2, 
        title: "Banner Ads",
        desc: "Your Ads will be placed beside the player (on website & TV) and below the player (on handheld devices)",
        img: "https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/da-banner-ads.png"
    }
]

function AdFormat(props) {
    const [videoAd, setVideoAd] = React.useState(1);
    const [displayAd, setDisplayAd] = React.useState(1);
    // React.useEffect(() => {
    //     const interval = setInterval(() => {
    //         let videoId = videoAd  == 1 ? 2 : videoAd == 2 ? 3 : 1;
    //         console.log(videoId, videoAd)
    //         setVideoAd(videoAd  == 1 ? 2 : videoAd == 2 ? 3 : 1)
    //       }, 2000);
    //       return () => clearInterval(interval);
    // }, [])
    return (
        <React.Fragment>
            <div className="advert-audience position-relative">
                <div className="card p-xxl-5 p-lg-4 p-md-3 p-0 w-100 border-0" style={{ background: "url(https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/audience.png) no-repeat center center", backgroundSize: "cover"}}>
                    <div className="banner-overlay-ad"/>
                    <div className="card-body p-5 text-center">
                        <h1 className="ff-ember-rg">Choose from different ad formats</h1>
                        <br/>
                        <h5 className="ff-ember-rg text-secondary">Drive Awareness, Increase Customers and Share your Brand Offers among a Highly Engaged Audience.</h5>
                    </div>
                </div>
            </div>
            <div className="row mt-xl-5 mt-5 pt-xxl-5 pt-lg-4 pt-md-3 pt-0 justify-content-between align-items-center ad-format">
                <div className='col-lg-5 col-12 order-lg-1 order-2 mt-md-0 mt-5'>
                    <h2 className="ff-ember-rg mb-4">
                        Video Ads
                    </h2>
                    {videoAds.map((ad, i) => 
                        <div 
                            className={classNames("ad-card", {"active": videoAd == ad.id})} 
                            onClick={() => {
                                setVideoAd(ad.id)
                            }}
                            key={i}
                        >
                            <h3 className="ff-ember-rg">{ad.title}</h3>
                            <p className="h6 ff-ember-lt">{ad.desc}</p>
                        </div>
                    )}
                    
                </div>
                <div className='col-lg-6 col-12 ps-4 order-lg-2 order-1'>
                    <img src={videoAds.filter(c => c.id == videoAd)[0].img} width="100%"/>
                </div>
            </div>
            <br/>
            <div className="row mt-xl-5 mt-md-4 mt-0 pt-xxl-5 pt-md-3 pt-0 justify-content-between align-items-center ad-format">
                <div className='col-lg-6 col-12 pe-4 text-center'>
                    <img src={displayAds.filter(c => c.id == videoAd)[0].img} width="50%" className="mx-auto"/>
                </div>
                <div className='col-lg-5 col-12 mt-md-0 mt-5'>
                    <h2 className="ff-ember-rg mb-4">
                        Display Ads
                    </h2>
                    {displayAds.map((ad, i) => 
                        <div 
                            className={classNames("ad-card", {"active": displayAd == ad.id})} 
                            onClick={() => {
                                setDisplayAd(ad.id)
                            }}
                            key={i}
                        >
                            <h3 className="ff-ember-rg">{ad.title}</h3>
                            <p className="h6 ff-ember-lt">{ad.desc}</p>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

export default AdFormat;